// v0.6.12 A2-183 / A2-184 — aggregating the per-run departure notice
// across the runs the operator has selected.
//
// Lives here rather than in CalculatePanel.jsx because that file is at
// its 500-line cap (tests/test_v06_loc_caps.py) and because this is
// plain data reduction with no React in it, so it is testable on its
// own.
//
// The backend (engine/unregistered_departures.py) decides WHETHER a
// country is unregistered — only a LOCAL registration is cover, and a
// run with no client is left alone. This only sums what it returned
// across several selected runs.

/** Distinct unregistered departure countries across the selected runs. */
export const aggregateUnregisteredCountries = (selectedRuns) => {
  const set = new Set();
  for (const r of selectedRuns || []) {
    for (const c of r?.unregistered_countries || []) {
      if (c) set.add(String(c).toUpperCase());
    }
  }
  return Array.from(set).sort();
};

/**
 * Same, keeping the row counts: [{country, rows, of_rows}].
 *
 * Two selected runs can both depart NL, so the counts add up and the
 * totals add up with them — "42 of 80 rows" across two files is the
 * honest reading, not "40 of 40" from whichever came last.
 */
export const aggregateUnregisteredDetail = (selectedRuns) => {
  const byCountry = new Map();
  for (const r of selectedRuns || []) {
    for (const d of r?.unregistered_departure_detail || []) {
      const cc = String(d?.country || "").toUpperCase();
      if (!cc) continue;
      const prev = byCountry.get(cc) || { country: cc, rows: 0, of_rows: 0 };
      prev.rows += Number(d.rows) || 0;
      prev.of_rows += Number(d.of_rows) || 0;
      byCountry.set(cc, prev);
    }
  }
  return Array.from(byCountry.values()).sort(
    (a, b) => a.country.localeCompare(b.country),
  );
};
